<div [@fadeIn] style="width: 360px" class="new-theme-typography">
    <div *ngIf="(authAlert$ | async) as alert" class="mb-3">
        <app-alert
            [level]="alert.level"
            [message]="alert.message"
            [dismissible]="true"
            [showIcon]="false"
            (dismissed)="dismissAlert()">
        </app-alert>
    </div>
    <div style="position: absolute; left: 50%; right: 50%; background: red; height: 20px; width: 20px;"></div>

    <ng-container [ngSwitch]="action">
        <app-account-locked *ngSwitchCase="'account-locked'"></app-account-locked>
        <app-reset-password *ngSwitchCase="'reset-password'"></app-reset-password>
        <app-login *ngSwitchDefault></app-login>
    </ng-container>

    <p class="text-center pt-4 font-normal">
        &copy; {{ getYear() }} Lendio &nbsp;&nbsp;|&nbsp;&nbsp;
        <a href="javascript:;" (click)="openTC()" class="cursor-pointer text-blue-400">Terms & Conditions</a>
    </p>
</div>
